// @flow

import { css } from 'styled-components';
import { BREAK_MD, BREAK_XL } from './Width';

type AlignOptions = 'center' | 'flex-start' | 'flex-end' | 'space-between' | 'space-around' | 'space-evenly' | 'stretch';

export const flex = (justify: AlignOptions = 'center', align: AlignOptions = 'center') => css`
  display: flex;
  justify-content: ${justify};
  align-items: ${align};
`;

export const inlineFlex = (justify: AlignOptions = 'center', align: AlignOptions = 'center') => css`
  display: inline-flex;
  justify-content: ${justify};
  align-items: ${align};
`;

export const flexInlineFlex = (mobileIsFlex: boolean, tabletIsFlex: boolean = true, desktopIsFlex: boolean = true) => css`
  display: ${mobileIsFlex ? 'flex' : 'inline-flex'};
  @media print, screen and (min-width: ${BREAK_MD}px) {
    display: ${tabletIsFlex ? 'flex' : 'inline-flex'};
  }
  @media print, screen and (min-width: ${BREAK_XL}px) {
    display: ${desktopIsFlex ? 'flex' : 'inline-flex'};
  }
`;

const ALIGN = {
  left: {
    flex: 'flex-start',
    text: 'left',
  },
  center: {
    flex: 'center',
    text: 'center',
  },
  right: {
    flex: 'flex-end',
    text: 'right',
  },
};

type AlignContentOptions = $Keys<typeof ALIGN>;

export const alignByBreakpoint = (mobile: AlignContentOptions, tablet?: AlignContentOptions, desktop?: AlignContentOptions) => css`
  align-items: ${ALIGN[mobile].flex};
  * {
    text-align: ${ALIGN[mobile].text};
  }

  ${tablet &&
    `@media print, screen and (min-width: ${BREAK_MD}px) {
       align-items: ${ALIGN[tablet].flex};
        * {
          text-align: ${ALIGN[tablet].text};
        }
    }`};

  ${desktop &&
    `@media print, screen and (min-width: ${BREAK_XL}px) {
      align-items: ${ALIGN[desktop].flex};
        * {
          text-align: ${ALIGN[desktop].text};
        }
    }`};
`;
